import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/';

import Create from "./Create.js"
import Edit from "./Edit.js"
import Delete from "./Delete.js"
import Detail from "./Detail.js"

import ParadigmaTable from "../../../components/ParadigmaTable/"



class TiposDeCosto extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "pk",
                    accessor: "pk",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Siglas",
                    id: "siglas",
                    accessor: d => d.siglas,
                    width: 100,
                    show: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create:true,
                        permission: 'tiposdecosto_add',
                        component: Create,
                    },
                    {
                        edit:true,
                        permission: 'tiposdecosto_edit',
                        component: Edit,
                    },
                    {
                        detail: true,
                        permission: 'tiposdecosto_detail',
                        component: Detail,
                    },
                    {
                        edit:true,
                        permission: 'tiposdecosto_delete',
                        component: Delete,
                    }
                ]}

                apiUrl={api.proyectos.config.presupuesto.tiposdecosto.list}
                columns={this.state.columns}
                exportUrl={api.proyectos.config.presupuesto.tiposdecosto.export}
                title={"Tipos de Costo"}
                outerSort={[{"id":"nombre","desc":false}]}
            />
        );
    }
}

export default TiposDeCosto;



// WEBPACK FOOTER //
// ./src/views/ProyectosConfig/Presupuesto_TiposDeCosto/TiposDeCosto.js